// src/utils/eventListeners.js
import supabase from '../supabase';
import NotificationHooks from './notificationHooks';
import { cleanupOldNotifications } from '../services/notificationsService';

/**
 * Configuración de escuchas de eventos en Supabase para generar notificaciones
 */
export const setupNotificationEventListeners = () => {
  console.log('Configurando escuchas de eventos para notificaciones...');

  // Canal para ofertas de trabajo
  const jobOffersChannel = supabase
    .channel('job_offers_changes')
    .on(
      'postgres_changes',
      {
        event: 'INSERT',
        schema: 'public',
        table: 'job_offers'
      },
      (payload) => {
        console.log('Nueva oferta de trabajo detectada:', payload.new.id);
        NotificationHooks.onJobOfferCreated(payload.new);
      }
    )
    .subscribe();

  // Canal para postulaciones a ofertas
  const jobApplicationsChannel = supabase
    .channel('job_applications_changes')
    .on(
      'postgres_changes',
      {
        event: 'INSERT',
        schema: 'public',
        table: 'job_applications'
      },
      (payload) => {
        console.log('Nueva postulación detectada:', payload.new.id);
        NotificationHooks.onJobApplicationReceived(payload.new);
      }
    )
    .on(
      'postgres_changes',
      {
        event: 'UPDATE',
        schema: 'public',
        table: 'job_applications',
        filter: 'status=neq.pending'
      },
      (payload) => {
        // Solo nos interesan cambios de estado
        if (payload.old.status !== payload.new.status) {
          console.log(`Cambio de estado en postulación: ${payload.old.status} → ${payload.new.status}`);
          NotificationHooks.onJobApplicationStatusChanged(payload.new, payload.old.status, payload.new.status);
        }
      }
    )
    .subscribe();

  // Canal para eventos
  const eventsChannel = supabase
    .channel('events_changes')
    .on(
      'postgres_changes',
      {
        event: 'INSERT',
        schema: 'public',
        table: 'events'
      },
      (payload) => {
        console.log('Nuevo evento detectado:', payload.new.id);
        NotificationHooks.onEventCreated(payload.new);
      }
    )
    .subscribe();

  // Canal para mensajes
  const messagesChannel = supabase
    .channel('messages_changes')
    .on(
      'postgres_changes',
      {
        event: 'INSERT',
        schema: 'public',
        table: 'messages'
      },
      (payload) => {
        console.log('🔔 Nuevo mensaje detectado por listener:', payload.new.id);
       if (NotificationHooks.onMessageSent && typeof NotificationHooks.onMessageSent === 'function') {
  NotificationHooks.onMessageSent(payload.new);
} else {
  console.log('🔔 Mensaje detectado pero onMessageSent no está disponible:', payload.new.id);
}
      }
    )
    .subscribe((status) => {
      console.log('Estado de suscripción a mensajes:', status);
    });

  // Canal para noticias
  const newsChannel = supabase
    .channel('news_changes')
    .on(
      'postgres_changes',
      {
        event: 'INSERT',
        schema: 'public',
        table: 'news',
        filter: 'is_published=eq.true'
      },
      (payload) => {
        console.log('Nueva noticia publicada detectada:', payload.new.id);
        NotificationHooks.onNewsPublished(payload.new);
      }
    )
    .on(
      'postgres_changes',
      {
        event: 'UPDATE',
        schema: 'public',
        table: 'news',
        filter: 'is_published=eq.true'
      },
      (payload) => {
        // Solo notificar si pasó de no publicada a publicada
        if (!payload.old.is_published && payload.new.is_published) {
          console.log('Noticia actualizada a publicada:', payload.new.id);
          NotificationHooks.onNewsPublished(payload.new);
        }
      }
    )
    .subscribe();

  // Canal para inscripciones en cursos
  const courseEnrollmentsChannel = supabase
    .channel('course_enrollments_changes')
    .on(
      'postgres_changes',
      {
        event: 'INSERT',
        schema: 'public',
        table: 'course_enrollments'
      },
      (payload) => {
        console.log('Nueva inscripción en curso detectada:', payload.new.id);
        NotificationHooks.onCourseEnrollment(payload.new);
      }
    )
    .subscribe();

  console.log('Escuchas de eventos configuradas correctamente');
  
  // Retornar los canales para poder desuscribirse más tarde si es necesario
  return {
    jobOffersChannel,
    jobApplicationsChannel,
    eventsChannel,
    messagesChannel,
    newsChannel,
    courseEnrollmentsChannel
  };
};

/**
 * Inicializa los componentes del sistema de notificaciones
 */
export const initializeNotificationSystem = () => {
  console.log('Inicializando sistema de notificaciones...');
  
  // Configurar escuchas de eventos
  const channels = setupNotificationEventListeners();
  
  // Programar limpieza automática de notificaciones antiguas
  const cleanupInterval = setInterval(async () => {
    try {
      const { success, count } = await cleanupOldNotifications();
      if (success && count > 0) {
        console.log(`Limpieza automática: ${count} notificaciones antiguas eliminadas`);
      }
    } catch (error) {
      console.error('Error en limpieza automática de notificaciones:', error);
    }
  }, 1000 * 60 * 60 * 24); // Ejecutar una vez al día
  
  return {
    channels,
    cleanupInterval
  };
};